import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { HOME_IMAGES } from "@/data/images";

const stagger = { animate: { transition: { staggerChildren: 0.08 } } };
const rise = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

const stats = [
  { k: "2+ YRS", v: "Experience" },
  { k: "50", v: "States Served" },
  { k: "24/7", v: "Dispatch" },
  { k: "100%", v: "Safety Focus" },
];

export function HomeHero() {
  return (
    <section className="relative min-h-[100vh] overflow-hidden pt-16">
      <div className="absolute inset-0">
        <img src={HOME_IMAGES.hero} alt="Truck on highway" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/70 to-brand-bg" />
        <div className="absolute inset-0 grid-pattern opacity-40" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-32">
        <motion.div initial="initial" animate="animate" variants={stagger} className="max-w-4xl">
          <motion.div variants={rise} className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-primary-brand" />
            <span className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand">
              Salt Lake City, UT · Serving All 50 States
            </span>
          </motion.div>
          <motion.h1
            variants={rise}
            className="font-heading text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black leading-[0.95] tracking-tighter"
          >
            MOVING FREIGHT<br />
            <span className="text-primary-brand">WITH CONFIDENCE.</span>
          </motion.h1>
          <motion.p variants={rise} className="mt-8 text-lg text-slate-700 max-w-2xl leading-relaxed">
            Laronta Pro Logistics LLC delivers dependable trucking and freight transportation
            across all 50 United States. Safe handling. On-time delivery. Outstanding service —
            every single mile.
          </motion.p>
          <motion.div variants={rise} className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/quote"
              data-testid="hero-quote-cta"
              className="group inline-flex items-center gap-2 bg-primary-brand hover:bg-[#E04F00] text-white px-8 py-4 font-bold uppercase tracking-wider text-sm transition-colors hover-shift"
            >
              Request a Free Quote
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              to="/track"
              data-testid="hero-track-cta"
              className="inline-flex items-center gap-2 border border-slate-900/30 hover:border-primary-brand hover:text-primary-brand text-slate-900 px-8 py-4 font-bold uppercase tracking-wider text-sm transition-colors"
            >
              Track a Shipment
              <ChevronRight className="h-4 w-4" />
            </Link>
          </motion.div>

          {/* Stat bar */}
          <motion.div variants={rise} className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
            {stats.map((s) => (
              <div key={s.v} className="bg-white px-6 py-6">
                <div className="font-heading text-2xl md:text-3xl font-black text-primary-brand">{s.k}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mt-1">{s.v}</div>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
